import type { MenuItem } from '@/types';

/**
 * Portal docs menu
 */
export const portalDocs: MenuItem[] = [
    {
        label: 'Portal',
        path: '/portal',
        openNested: true,
        submenu: [
              {
                label: 'Channel',
                path: '/portal/portal-channels',
              },              
              {
                label: 'Rooms',
                path: '/portal/portal-rooms',
              },   
              {
                label: 'Analytics',
                path: '/portal/portal-analytics',
              },   
              {
                label: 'Dashboard',
                path: '/portal/portal-dashboard',
              },   
              {
                label: 'List and Find',
                path: '/portal/portal-list-and-find',
              },       

              {
                label: 'Viewing Streams',
                path: '/portal/view-streams',
              },
              {
                label: 'Properties',
                path: '/portal/portal-properties',
              }, 
              {
                label: 'Messages',
                path: '/portal/portal-messages',
              },            
         
              {
                label: 'Publish URI',
                path: '/portal/publish',
              }, 
              {
                label: 'Create a Channel or Room',
                path: '/portal/create-a-channel-or-room-using-the-phenix-portal',
              },
              {
                label: 'Create EdgeAuth Tokens',
                path: '/portal/creating-edgeauth-tokens-in-the-portal',
              },
              {
                label: 'Decode EdgeAuth Tokens',
                path: '/portal/decoding-edgeauth-tokens-in-the-portal',
              },
          {
            label: 'Release Notes',
            path: '/portal/portal-release-notes',
          },
        ],
      },
];
